import { Component, OnInit, Input, ViewChild, ElementRef } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { DashboardService } from "../../../../../services/dashboard.service";
import { SharedService } from "../../../../../services/shared.service";

@Component({
  selector: "app-image-form",
  templateUrl: "./image-form.component.html",
  styleUrls: ["./image-form.component.css"],
})
export class ImageFormComponent implements OnInit {
  public message: string;
  blocco: any;
  form: FormGroup;
  imgURL: any;
  @ViewChild("fileInput") fileInput: ElementRef;

  constructor(
    private formBuilder: FormBuilder,
    private _dashboardService: DashboardService,
    private _sharedService: SharedService
  ) {}

  ngOnInit() {
    this.blocco = this._sharedService.getBlocco();
    this.form = this.formBuilder.group({
      image: [this.blocco.descrizione, Validators.required],
    });
  }

  onFileChange(event) {
    if (event.target.files.length > 0) {
      let file = event.target.files[0];
      this.form.get("image").setValue(file);
      const mimeType = file.type;

      const blocco = this._sharedService.getBlocco();
      // uploadImage
      this._dashboardService
        .uploadFile({ token: blocco.token, id: 5, file: file })
        .subscribe(
          (uploaded) => {
            // updateBlocco
            this._dashboardService
              .updateBlocco({
                ...blocco,
                imageSrc: `${blocco.token}/${uploaded.token}`,
                descrizione: file.name,
              })
              .subscribe(
                (updateRes) => {
                  this.blocco = updateRes;
                  this._sharedService.setBlocco(updateRes);
                },
                (err) => {}
              );
          },
          (err) => {}
        );
    }
  }

  clearFile() {
    this.form.get("image").setValue(null);
    this.blocco.descrizione = "";
    // this.fileInput.nativeElement.value = '';
    // updateBlocco
    this._dashboardService
      .updateBlocco({
        ...this.blocco,
        imageSrc: "",
      })
      .subscribe(
        (updateRes) => {},
        (err) => {}
      );
  }
  image = () => this.form.get("image").value;
  imageJSON = () => JSON.stringify(this.form.get("image").value);
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/item-type-manager/forms/image-form/image-form.component.ts